<template>
    <span>{{ shown }}<span v-if="active" class="typed-text__cursor cursor">_</span><span class="typed-text__rest">{{ rest }}</span></span>
</template>

<script>
import { computed, inject } from 'vue';

/**
 * Text typed out by the surrounding <TypeReveal>, with a cursor at the front
 * while it is being typed. The untyped rest keeps its place, invisible, so the
 * layout doesn't move.
 */
export default {
    name: 'TypedText',
    props: {
        text: { type: String, required: true },
    },
    setup(props) {
        const { typed, register } = inject('typeReveal');
        const start = register(props.text.length);
        const count = computed(() => Math.min(Math.max(typed.value - start, 0), props.text.length));

        return {
            shown: computed(() => props.text.slice(0, count.value)),
            rest: computed(() => props.text.slice(count.value)),
            active: computed(() => typed.value >= start && typed.value < start + props.text.length),
        };
    },
};
</script>

<style scoped>
/* Out of flow (drawn where the text stops) so it never pushes or re-wraps the text. */
.typed-text__cursor {
    position: absolute;
}
.typed-text__rest {
    visibility: hidden;
}
</style>
